import { Navigate, useLocation } from 'react-router-dom'
import { legacyDatabaseOnboardingTarget } from '../utils/onboardingPaths'

/** /database/onboarding → /database/new or /database/connect (preserve query string). */
export function LegacyDatabaseOnboardingRedirect() {
  const { search } = useLocation()
  return <Navigate to={legacyDatabaseOnboardingTarget(search)} replace />
}
